import React, {createContext, useReducer} from 'react';
import {RESOLUTION_STATE_VALUES} from "../constants/local-storage";
import {CHANGE_PAGE_ID} from "../constants/action-types";
import {CHANGE_PAGE_TITLE} from "../constants/action-types";
import {CHANGE_LOGGED_IN} from "../constants/action-types";
import {CHANGE_PERIOD_REPORT_ID} from "../constants/action-types";
import {CHANGE_PERIOD_REPORT_NAME} from "../constants/action-types";
import {CHANGE_ADMIN_NAVIGATOR_SECTION} from "../constants/action-types";
import {CHANGE_ADMIN_LIST} from "../constants/action-types";
import {CHANGE_ADMIN_FORM} from "../constants/action-types";
import {CHANGE_ADMIN_ID} from "../constants/action-types";
import {CHANGE_THEME} from "../constants/action-types";
import {CHANGE_THEME_TEXT_COLOR} from "../constants/action-types";
import {CHANGE_CLIENT} from "../constants/action-types";
import {CHANGE_SCAN_WINDOW_HIDE} from "../constants/action-types";
import {CHANGE_REMAINING_CONTENT_Z_INDEX} from "../constants/action-types";
import {CHANGE_AREA_UNIT} from "../constants/action-types";
import {CHANGE_FILTER} from "../constants/action-types";
import {CHANGE_QUERY_CONTEXT} from "../constants/action-types";
import {CHANGE_DASHBOARD_SEARCH_CRITERIA} from "../constants/action-types";
import {CHANGE_DOCUMENT_BASKET} from "../constants/action-types";




const initialState = JSON.parse(localStorage.getItem(RESOLUTION_STATE_VALUES));
const store = createContext(initialState);
const {Provider} = store;

const StateProvider = ({children}) => {
	const [state, dispatch] = useReducer((state, action) => {
		var addState = {};
		switch(action.type){
			case CHANGE_PAGE_ID:
				addState = {...state, selectedPageId:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;
				
			case CHANGE_PAGE_TITLE:
				addState = {...state, pageTitle:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;
			
			case CHANGE_LOGGED_IN:
				addState = {...state, loggedIn:action.value};
				localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;
				
			case CHANGE_PERIOD_REPORT_ID:
				addState = {...state, periodReportId:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;	
				
			case CHANGE_PERIOD_REPORT_NAME:
				addState = {...state, periodReportName:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;	
				
			case CHANGE_ADMIN_NAVIGATOR_SECTION:
				addState = {...state, adminNavigatorSection:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;	
				
			case CHANGE_ADMIN_LIST:
				addState = {...state, adminList:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;
				
			case CHANGE_ADMIN_FORM:
				addState = {...state, adminForm:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;		
				
			case CHANGE_ADMIN_ID:
				addState = {...state, adminId:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;		
				
				
			case CHANGE_THEME:
				addState = {...state, theme:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;	
				
			case CHANGE_THEME_TEXT_COLOR:
				addState = {...state, themeTextColor:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;	
			
			case CHANGE_CLIENT:
				addState = {...state, client:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;	
				
			case CHANGE_SCAN_WINDOW_HIDE:
				addState = {...state, scanWindowHide:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;			
				
			case CHANGE_REMAINING_CONTENT_Z_INDEX:
				addState = {...state, remainingContentZIndex:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;		
			
			case CHANGE_AREA_UNIT:
				addState = {...state, areaUnit:action.value};
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;		
				
			case CHANGE_FILTER:
				addState = {...state, filter:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;		
				
			case CHANGE_QUERY_CONTEXT:
				addState = {...state, queryContext:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;		
				
			case CHANGE_DASHBOARD_SEARCH_CRITERIA:
				addState = {...state, dashboardSearchCriteria:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;	
				
			case CHANGE_DOCUMENT_BASKET:
					addState = {...state, documentBasket:action.value}
				  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
					return addState;		
				
			
			default:
			 return '';
		}
	}, initialState);
	
	return <Provider value={{state, dispatch}}>{children}</Provider>;
};

export {store, StateProvider}
